export enum AdditionalInfoAction {
  EDIT = "EDIT",
  DELETE = "DELETE",
}
